import { z } from 'zod';
/** Clave de preferencia: letras, números y `. _ : -` (p. ej. `dashboard.dismissed.failed`). */
export const preferenceKey = z
    .string()
    .regex(/^[a-z0-9][a-z0-9._:-]{0,99}$/i, 'Clave de preferencia inválida');
/** Valor JSON chico (hasta 4 KB serializado). */
export const preferenceInput = z.object({
    value: z
        .json()
        .refine((v) => JSON.stringify(v).length <= 4096, 'El valor es demasiado grande (máximo 4 KB)'),
});
//# sourceMappingURL=preferences.js.map